"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  dismissed: false,
  level: 'DEFAULT',
  loading: false,
  timestamp: 0
};

var PortalDismissStatus =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(PortalDismissStatus, _Record);

  function PortalDismissStatus() {
    (0, _classCallCheck2.default)(this, PortalDismissStatus);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PortalDismissStatus).apply(this, arguments));
  }

  (0, _createClass2.default)(PortalDismissStatus, [{
    key: "isLoading",
    value: function isLoading() {
      return this.loading;
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new PortalDismissStatus(json);
    }
  }]);
  return PortalDismissStatus;
}((0, _immutable.Record)(defaults));

var _default = PortalDismissStatus;
exports.default = _default;
module.exports = exports.default;